import axios from '../utils/axios'


export function QVideoStreamApi(params) {
  return axios.post('/trace/QVideoStreamApi', params);
}
